import "../../exam/components/Layout/Header.css";
import Button from "../../../../shared/components/Button/Button";
import images from "../../../../utilities/images/images";
import ExerciseTimer from "./ExerciseTimer";

const ExerciseHeader = ({
  timerSeconds,
  isCountdown,
  onExitClick,
  onSubmit,
}) => {
  return (
    <div className="header-container">
      <div className="header-left" onClick={onExitClick}>
        <img src={images.new_backarrow} alt="Back" className="back-icon" />
      </div>

      <div className="header-center">
        <ExerciseTimer seconds={timerSeconds} isCountdown={isCountdown} />
      </div>

      <div className="header-right">
        <Button
          title="Submit"
          variant="outlined"
          color="error"
          onClick={onSubmit}
          accessor="exercise-submit-btn"
          className="header-submit-btn"
        />
      </div>
    </div>
  );
};

export default ExerciseHeader;
